import { createRoot } from 'react-dom/client'
import { ChatbotSidebar } from './ChatbotSidebar'
import { MountConfig } from './protocol'
import './chatbot.css'

// LF-918: mounts the guidebook chatbot wherever the page renders
// shared/_chatbot_sidebar (the report, home and chatbot pages). Imported by
// both Vite entrypoints, ahead of anything that might stop early.
const mount = () => {
  const container = document.querySelector('[data-chatbot-root]')
  if (!(container instanceof HTMLElement)) return

  const parsed = MountConfig.safeParse(
    JSON.parse(container.dataset.chatbotRoot ?? 'null'),
  )
  if (!parsed.success) {
    throw new Error(`Invalid chatbot config: ${parsed.error.message}`)
  }
  createRoot(container).render(<ChatbotSidebar config={parsed.data} />)
}

mount()
